import { FC, useRef, useState, useLayoutEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import "./EllipsisTooltip.scss";

const TOOLTIP_SX = {
    bgcolor: "#707070",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    padding: "8px 13px",
    boxShadow: "0px 4px 8px rgba(255, 244, 244, 0.1)",
};

interface EllipsisTooltipProps {
    text: string;
    className?: string;
}

const EllipsisTooltip: FC<EllipsisTooltipProps> = ({ text, className }) => {
    const ref = useRef<HTMLSpanElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useLayoutEffect(() => {
        const el = ref.current;
        if (el) {
            setIsOverflowing(el.scrollWidth > el.clientWidth);
        }
    }, [text]);

    return (
        <Tooltip
            title={isOverflowing ? text : ""}
            placement="bottom-start"
            slotProps={{ tooltip: { sx: TOOLTIP_SX } }}
        >
            <span
                ref={ref}
                className={`ellipsis_tooltip${isOverflowing ? " ellipsis_tooltip--overflow" : ""}${className ? ` ${className}` : ""}`}
            >
                {text}
            </span>
        </Tooltip>
    );
};

export default EllipsisTooltip;
